export default __webpack_public_path__ + "static/media/0x56a0efefc9f1fbb54fbd25629ac2aa764f1b56f7.8c01d3b6.webp";